import { useRef, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LiveLinkViewer from './LiveLinkViewer';
import { useGoogleMap } from './hooks/useGoogleMap';
import { MAP_CONFIG } from './config/mapConfig';
import { loadGoogleMaps } from './utils/loadGoogleMaps';
import { LoadingMessage, ErrorMessage } from './components';
import './App.css';

function DefaultMapView() {
  const mapContainerRef = useRef<HTMLDivElement>(null);

  useGoogleMap(mapContainerRef, {
    center: MAP_CONFIG.DEFAULT_CENTER,
    zoom: MAP_CONFIG.DEFAULT_ZOOM,
    showMapTypeSelector: MAP_CONFIG.SHOW_MAP_TYPE_SELECTOR,
    mapType: MAP_CONFIG.DEFAULT_MAP_TYPE
  });

  return (
    <div className="default-map-view">
      <div
        ref={mapContainerRef}
        className="google-map-container"
      />
      <div className="welcome-banner">
        <h3>Outerlink Live Link Viewer</h3>
        <p>
          Use { `${window.location.protocol}//${window.location.host}/[live-link-id]` } to view a live link
        </p>
      </div>
    </div>
  );
}

function App() {
  const [mapsLoaded, setMapsLoaded] = useState(false);
  const [mapsError, setMapsError] = useState<string | null>(null);

  useEffect(() => {
    loadGoogleMaps()
      .then(() => setMapsLoaded(true))
      .catch((error) => {
        console.error('Failed to load Google Maps:', error);
        setMapsError(error.message);
      });
  }, []);

  if (mapsError) {
    return <ErrorMessage title="Error Loading Google Maps" message={mapsError} />;
  }

  if (!mapsLoaded) {
    return <LoadingMessage message="Loading Google Maps..." />;
  }

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/v3/:liveLinkId" element={<LiveLinkViewer apiVersion="v3" />} />
          <Route path="/:liveLinkId" element={<LiveLinkViewer />} />
          <Route path="/" element={<DefaultMapView />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
